<template>
    <div class="forex-index">
        <page-navigate></page-navigate>
        <div>
            <div class="forex-wrapper cn">
                <forexMenu />
                <div class="forex-wrapper-body">
                    <h1 class="forex-title">EBC交易学院，跟随专家学交易</h1>
                    <p class="forex-sub-title">
                        我们致力于提供您交易之路上所需的一切帮助，从名师讲堂、全球资讯到实用工具，陪伴您的交易每一天
                    </p>
                    <div id="search-box-index">
                        <div class="search-box">
                            <el-autocomplete ref="autocomplete" @keydown.enter.native="handleSearch"
                                prefix-icon="el-icon-search" :fetch-suggestions="querySearchAsync"
                                :trigger-on-focus="false" placeholder="输入关键词" v-model="searchValue"
                                class="input-with-select" value-key="label">
                                <template slot-scope="{ item }">
                                    <a :href="item.url" class="custom-template" v-html="item.value"></a>
                                </template>
                                <div slot="prepend" v-if="!isMobile">
                                    <el-select v-model="typeValue" placeholder="">
                                        <el-option v-for="type in searchTypeList" :label="type.name" :value="type.id"
                                            :key="type.id"></el-option>
                                    </el-select>
                                    <div class="search-line"></div>
                                </div>
                                <div style="height: 100%; display: flex; align-items: baseline" slot="suffix">
                                    <span v-if="searchValue" @click="searchValue = ''">
                                        <i class="el-icon-error search-clean-icon"></i>
                                    </span>
                                    <a href="javascript:;" @click.stop="handleSearch" class="my-search-btn">搜索</a>
                                </div>
                            </el-autocomplete>
                        </div>
                    </div>
                    <section class="forex-section">
                        <div class="forex-section-title-box">
                            <h2 class="forex-section-title">财经日历</h2>
                        </div>
                        <div class="forex-section-content">

                            <iframe id="TCIframe" class="scrollbar-container" :src="TCIframe"></iframe>
                        </div>
                    </section>
                    <section class="forex-section">
                        <div class="forex-section-title-box">
                            <h2 class="forex-section-title">账户分析系统</h2>
                        </div>
                        <div class="section3-content forex-section-content">
                            <div class="section3-content-left">
                                <h3 class="section3-title">一步鉴别优质交易</h3>
                                <p class="section3-intro">
                                    EBC
                                    独家盈亏统计和历史回溯工具，基于多维评价系统与深度嵌入模型，全面解析交易细节，助力优化交易策略
                                </p>
                                <div class="section3-btn-box">
                                    <a href="https://ebcturbo.com/tools?language=zh&utm_source=ebccom" target="_blank"
                                        rel="nofollow" class="ebc-btn">开始分析</a>
                                    <a href="/jinrong/ebc-ea-turbo/" class="ebc-btn" type-line>使用方法</a>
                                </div>
                            </div>
                            <div class="section3-content-right">
                                <div class="swiper-container section3-swiper-wrapper">
                                    <!-- 使用 vue-awesome-swiper 的组件 -->
                                    <swiper ref="mySwiper" :options="swiperOptions" class="swiper">
                                        <!-- Slide 1: 六维评级图 -->
                                        <swiper-slide class="swiper-slide">
                                            <div class="section3-item">
                                                <h3 class="section3-item-title">六维评级图</h3>
                                                <div class="section3-img-box">
                                                    <div class="section3-item-text">收益率</div>
                                                    <div class="section3-img-inner-box">
                                                        <div class="section3-img-inner-left">
                                                            <div class="section3-item-text">最大回撤</div>
                                                            <div class="section3-item-text">标准差</div>
                                                        </div>
                                                        <img class="section3-inner-img"
                                                            src="../../assets/image/forex/index_new/section_bg1.png"
                                                            alt="" />
                                                        <div class="section3-img-inner-right">
                                                            <div class="section3-item-text">获利系数</div>
                                                            <div class="section3-item-text">夏普比率</div>
                                                        </div>
                                                    </div>
                                                    <div class="section3-item-text">盈利交易（胜率）</div>
                                                </div>
                                            </div>
                                        </swiper-slide>

                                        <!-- Slide 2: 每日/月度统计 -->
                                        <swiper-slide class="swiper-slide">
                                            <div class="section3-item">
                                                <h3 class="section3-item-title">每日/月度统计</h3>
                                                <img src="../../assets/image/forex/index_new/section_bg2.png" alt=""
                                                    class="section3-item-img" />
                                            </div>
                                        </swiper-slide>

                                        <!-- Slide 3: 净值收益曲线 -->
                                        <swiper-slide class="swiper-slide">
                                            <div class="section3-item">
                                                <h3 class="section3-item-title">净值收益曲线</h3>
                                                <img src="../../assets/image/forex/index_new/section_bg3.png" alt=""
                                                    class="section3-item-img" />
                                            </div>
                                        </swiper-slide>

                                        <!-- 分页器（由 Swiper 自动渲染到此位置） -->
                                        <div class="swiper-pagination" slot="pagination"></div>
                                    </swiper>

                                </div>
                            </div>
                        </div>
                    </section>

                    <section class="forex-section">
                        <div class="forex-section-title-box">
                            <h2 class="forex-section-title">交易计算器</h2>
                            <a href="/forex-tools/" class="ebc-text-btn">
                                查看更多 <span class="iconfont icon-chevron_right"></span>
                            </a>
                        </div>
                        <div class="section5-content forex-section-content">
                            <a href="/forex-tools/pivot-points-calculator/" class="section5-item">
                                <img class="section5-item-icon" src="../../assets/image/forex/index_new/icon1.png"
                                    alt="" />
                                <h3 class="section5-item-title">枢轴点计算器</h3>

                                <span class="section5-item-btn ebc-text-btn">立即使用<span
                                        class="iconfont icon-chevron_right"></span></span>
                            </a>
                            <a href="/forex-tools/fibonacci-calculator/" class="section5-item">
                                <img class="section5-item-icon" src="../../assets/image/forex/index_new/icon2.png"
                                    alt="" />
                                <h3 class="section5-item-title">斐波那契计算器</h3>

                                <span class="section5-item-btn ebc-text-btn">立即使用<span
                                        class="iconfont icon-chevron_right"></span></span>
                            </a>
                            <a href="/forex-tools/pip-value-calculator/" class="section5-item">
                                <img class="section5-item-icon" src="../../assets/image/forex/index_new/icon3.png"
                                    alt="" />
                                <h3 class="section5-item-title">点值计算器</h3>

                                <span class="section5-item-btn ebc-text-btn">立即使用<span
                                        class="iconfont icon-chevron_right"></span></span>
                            </a>
                            <a href="/forex-tools/position-size-calculator/" class="section5-item">
                                <img class="section5-item-icon" src="../../assets/image/forex/index_new/icon4.png"
                                    alt="" />
                                <h3 class="section5-item-title">头寸规模计算器</h3>

                                <span class="section5-item-btn ebc-text-btn">立即使用<span
                                        class="iconfont icon-chevron_right"></span></span>
                            </a>
                            <a href="/forex-tools/risk-reward-calculator/" class="section5-item">
                                <img class="section5-item-icon" src="../../assets/image/forex/index_new/icon5.png"
                                    alt="" />
                                <h3 class="section5-item-title">风险和收益计算器</h3>

                                <span class="section5-item-btn ebc-text-btn">立即使用<span
                                        class="iconfont icon-chevron_right"></span></span>
                            </a>
                            <a href="/forex-tools/gain-loss-percentage-calculator/" class="section5-item">
                                <img class="section5-item-icon" src="../../assets/image/forex/index_new/icon6.png"
                                    alt="" />
                                <h3 class="section5-item-title">损益百分比计算器</h3>

                                <span class="section5-item-btn ebc-text-btn">立即使用<span
                                        class="iconfont icon-chevron_right"></span></span>
                            </a>
                        </div>
                    </section>
                    <section class="forex-section">
                        <div class="forex-section-title-box">
                            <h2 class="forex-section-title">分析报告 </h2>
                            <a href="/jinrong/shujubaogao/" class="ebc-text-btn">
                                查看更多 <span class="iconfont icon-chevron_right"></span>
                            </a>
                        </div>
                        <div class="forex-section-content">
                            <div class="swiper-container forex-reports">


                                <swiper ref="swiperRecommendedReports" :options="swiperRecommendedReportsOptions"
                                    class="swiper">
                                    <swiper-slide class="swiper-slide" v-for="item in recommended_reports"
                                        :key="item.id">
                                        <div class="forex-document-item">
                                            <a :href="removeZhCnLink(item.url)" class="forex-document-item-img-box">
                                                <img class="forex-document-item-img" :src="item.thumbnail" alt="" />
                                            </a>
                                            <div>
                                                <a :href="removeZhCnLink(item.url)"
                                                    class="forex-document-item-title text-ellipsis-2">
                                                    {{ item.post_title }}</a>
                                                <div class="forex-document-item-time">
                                                    {{ formateTime(item.published_time) }}
                                                </div>
                                            </div>
                                        </div>
                                    </swiper-slide>
                                </swiper>

                            </div>
                        </div>
                    </section>

                    <section class="forex-section">
                        <div class="forex-section-title-box">
                            <h2 class="forex-section-title">今日投资热点</h2>
                            <a href="/jinrong/jinrongjiaodian/" class="ebc-text-btn">
                                查看更多 <span class="iconfont icon-chevron_right"></span>
                            </a>
                        </div>
                        <div class="forex-section-content">
                            <div class="swiper-container forex-news">

                                <swiper ref="swiperRecommendedFocus" :options="swiperRecommendedFocusOptions"
                                    class="swiper">
                                    <swiper-slide class="swiper-slide" v-for="item in recommended_focus" :key="item.id">
                                        <div class="forex-document-item">
                                            <a :href="removeZhCnLink(item.url)" class="forex-document-item-img-box">
                                                <img class="forex-document-item-img" :src="item.thumbnail" alt="" />
                                            </a>
                                            <div>
                                                <a :href="removeZhCnLink(item.url)"
                                                    class="forex-document-item-title text-ellipsis-2">
                                                    {{ item.post_title }}</a>
                                                <div class="forex-document-item-time">
                                                    {{ formateTime(item.published_time) }}
                                                </div>
                                            </div>
                                        </div>
                                    </swiper-slide>
                                </swiper>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>

        <page-footer></page-footer>
    </div>
</template>

<script>
import moment from 'moment';
import forexMenu from '../../components/forex-menu/forex-menu.vue';
import { getAcademyHome, getSearchSuggestions } from '../../serve/forex.js';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'

const words = [
    '外汇', '保证金', '炒汇', '炒币', 'CFD', '差价合约',
    '虚拟货币', '加密货币', '数字货币', '比特币', 'BTC',
    '以太坊', 'ETH', '台湾', '出金', '入金', '现货'
];

let searchTypeList = [
    { id: "all", name: "全部", parent_id: 0, children: [] },
    { id: 142, name: "交易词典", parent_id: 0, children: [] },
    { id: 4, name: "金融知识", parent_id: 0, children: [] },
    { id: 143, name: "市场传奇", parent_id: 0, children: [] },
    { id: 8, name: "金融焦点", parent_id: 0, children: [] },
    { id: 7, name: "数据报告", parent_id: 0, children: [] },
    { id: 146, name: "市场期刊", parent_id: 0, children: [] },
];
let lang = "zh-cn";
export default {
    components: {
        forexMenu,
        Swiper, SwiperSlide
    },
    data() {
        return {
            searchValue: "",
            typeValue: "all",
            searchTypeList: searchTypeList,
            restaurants: [],
            TCIframe: "",
            isMobile: false,
            academyHomeData: null, // 存储学院首页数据
            recommended_focus: [],
            recommended_reports: [],
            swiperOptions: {
                loop: true,
                centeredSlides: true,
                slidesPerView: 'auto',
                spaceBetween: 0,
                grabCursor: true,
                speed: 600,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                    dynamicBullets: true
                },
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false
                }
            },
            swiperRecommendedFocusOptions: {
                slidesPerView: 3,
                spaceBetween: 20,
                observer: true,
                observeParents: true,

                breakpoints: {
                    // 当容器宽度 <= 996px 时
                    0: {
                        // 这里定义了最小断点，覆盖所有小尺寸
                        slidesPerView: 1.1,
                        spaceBetween: 15,
                    },
                    997: {
                        // 当容器宽度 >= 997px 时恢复默认设置
                        slidesPerView: 3,
                        spaceBetween: 20,
                    },
                },
            },
            swiperRecommendedReportsOptions: {
                slidesPerView: 3,
                spaceBetween: 20,
                observer: true,
                observeParents: true,

                breakpoints: {
                    // 当容器宽度 <= 996px 时
                    0: {
                        // 这里定义了最小断点，覆盖所有小尺寸
                        slidesPerView: 1.1,
                        spaceBetween: 15,
                    },
                    997: {
                        // 当容器宽度 >= 997px 时恢复默认设置
                        slidesPerView: 3,
                        spaceBetween: 20,
                    },
                },
            }
        };
    },

    computed: {

    },
    created() {
        this.getUrl();
        this.getAcademyHomeData();
    },
    mounted() {
        this.checkScreenWidth(); // 初始化判断
        window.addEventListener("resize", this.checkScreenWidth); // 监听窗口变化
    },
    filters: {},
    methods: {
        querySearchAsync(queryString, cb) {
            getSearchSuggestions(queryString, this.typeValue).then((response) => {
                if (response.status && response.status == "200" && response.data && response.data.status && response.data.status == "success") {
                    let result = response.data.data.suggestions.map((el) => {
                        return {
                            value: el.title,
                            url: el.url.replace("/zh-cn", ""),
                            label: el.title.replace(/<em>(.*?)<\/em>/g, "$1"),
                        };
                    });
                    let result2 = result.filter(item => {
                        // 检查 label 是否包含 words 中的任意一个词
                        const hasForbiddenWord = words.some(word =>
                            item.label.includes(word)
                        );
                        return !hasForbiddenWord; // 不包含才保留
                    })
                    cb(result2);
                } else {
                    cb([]);
                }
            }).catch((error) => {
                cb([]);
            });
        },
        checkScreenWidth() {
            this.isMobile = window.innerWidth <= 996;
        },
        // 搜索跳转
        handleSearch() {
            if (!this.searchValue) {
                return;
            }
            this.$router.push(`/jinrong/search?sort=${this.typeValue}&word=${this.searchValue}`);
            // let l = window.location.pathname;
            // window.location.href = `${l}search?sort=${this.typeValue}&word=${this.searchValue}`;
        },
        getUrl() {
            const formData = new FormData();
            formData.append('lang', 'cs');
            fetch('https://ebccfd.com/TradingCentral/EconomicCalendar/', {
                method: 'POST',
                body: formData
            }).then((res) => {
                return res.text()
            }).then((res) => {
                this.TCIframe = res;
            }).catch(() => {

            })

        },
        // 获取学院首页数据
        getAcademyHomeData() {
            getAcademyHome().then(res => {
                if (res.data && res.data.code === 1) {
                    this.academyHomeData = res.data.data;
                    this.recommended_focus = this.academyHomeData.recommended_focus
                    this.recommended_reports = this.academyHomeData.recommended_reports
                } else {
                }
            }).catch(error => {
            });
        },
        formateTime(time) {
            return moment.unix(new Date(time)).format("YYYY-MM-DD")
        },
        removeZhCnLink(link) {
            return link.replace("/zh-cn", "");
        }
    },
}
</script>

<style>
    body{
        font-family: "Inter", "Noto Sans", "Noto Sans SC", sans-serif !important;
    }
</style>
<style scoped>
@import url("../../assets/css/forex/rem.css");
@import url("../../assets/css/forex/common.css");

.forex-index {
    font-family: "Inter", "Noto Sans", "Noto Sans SC", sans-serif !important;
}



.forex-wrapper .forex-title {
    color: var(--Text-Primary, #000);
    font-size: 64rem;
    font-style: normal;
    font-weight: 700;
    line-height: 72rem;
}

.forex-sub-title {
    margin-top: 24rem;
    color: var(--Text-Secondary, rgba(0, 0, 0, 0.64));
    font-size: 20rem;
    font-style: normal;
    font-weight: 400;
    line-height: 28rem;
}

.search-box {
    margin-top: 56rem;
}

.section1 {
    margin-top: 56rem;
}

#ProductIframe,
#TCIframe {
    width: 100%;
    height: 654rem;
    border-radius: var(--Corner-Radius-RC12, 12rem);
    border: 1px solid #ebebeb;
}

#ProductIframe {
    height: 740rem;
    padding-top: 16rem;
}


.section3-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 24rem 32rem;
    border-radius: var(--Corner-Radius-RC12, 12rem);
    border: 1px solid #ebebeb;
    background: var(--Neutral-BG_A, #fff);
    gap: 114rem;
}

.section3-content .swiper-container {
    overflow: hidden;
    padding-bottom: 40rem;
}

.section3-content-left {
    display: flex;
    flex-direction: column;
}

.section3-content-right {
    flex-shrink: 0;
    width: 450rem;
}

.section3-content-right img {
    /* height: 215rem; */
}

::v-deep .section3-swiper-wrapper {
    position: relative;
    padding-bottom: 40rem;
    perspective: 1200px;
}

/* 2. 启用 3D 渲染上下文 */
::v-deep .section3-swiper-wrapper .swiper-wrapper {
    transform-style: preserve-3d;
}

/* .section3-swiper-wrapper::before {
  content: "";
  height: 100%;
  width: 40rem;
  background: linear-gradient(270deg, rgba(256, 256, 256, 0) 0%, #fff 100%);
  position: absolute;
  left: 0;
  top: 0;
  z-index: 99;
}
.section3-swiper-wrapper::after {
  content: "";
  height: 100%;
  width: 40rem;
  background: linear-gradient(90deg, rgba(256, 256, 256, 0) 0%, #fff 100%);
  position: absolute;
  right: 0;
  top: 0;
  z-index: 99;
} */
::v-deep .section3-swiper-wrapper .swiper-slide {
    width: 380rem;
    height: 290rem;
    display: flex;
    justify-content: center;
    align-items: center;
    /* opacity: 0.7; */
    transition: all 0.4s ease;
    /* transform: scale(0.9); */
    border-radius: 8rem;
    background: #fafafa;
    opacity: 0.8;
    transition: transform 0.6s ease, opacity 0.6s ease;
    backface-visibility: hidden;
    will-change: transform;
    transform-style: preserve-3d;
    /* 必须！ */
}

/* 居中激活项：正面、不倾斜、最清晰 */
::v-deep .section3-swiper-wrapper .swiper-slide-active {
    transform: scale(1) rotateY(0deg) translateX(0);
    opacity: 1;
    z-index: 4;
    filter: blur(0);
    background: #fafafa;
}


::v-deep .section3-swiper-wrapper .swiper-slide::before {
    position: absolute;
    left: 0;
    top: 0;
    content: "";
    width: 100%;
    height: 100%;
    background: linear-gradient(270deg, #f2f2f2, #fafafa);
    z-index: 3;
    opacity: 1;
    transition: all 0.42s;
    border-radius: 8rem;
}

::v-deep .section3-swiper-wrapper .swiper-slide-next::before {
    background: linear-gradient(90deg, #f2f2f2, #fafafa);
}

::v-deep .section3-swiper-wrapper .swiper-slide-active::before {
    opacity: 0;
}

/* 左侧项：向右倾斜（rotateY 负值） */
::v-deep .section3-swiper-wrapper .swiper-slide-prev {
    position: relative;
    transform: scale(.8) rotateY(30deg) translateX(25%);
    opacity: 0.9;
    z-index: 2;
    background: #f2f2f2;

}

/* 右侧项：向左倾斜（rotateY 正值） */
::v-deep .section3-swiper-wrapper .swiper-slide-next {
    transform: scale(.8) rotateY(-30deg) translateX(-25%);
    opacity: 0.9;
    z-index: 2;
    background: #f2f2f2;
}



.section3-item-title {
    color: var(--Text-Primary, #000);
    font-size: 14rem;
    font-style: normal;
    font-weight: 500;
    line-height: 24rem;
    text-align: center;
    margin-bottom: 16rem;
}

::v-deep .swiper-pagination-bullet {
    /* width: 10px;
  height: 4px; */
    display: inline-block;
    background: #bbb;
    opacity: 0.5;
    /* border-radius: 2px; */
}

::v-deep .swiper-pagination-bullet-active {
    background: rgba(0, 0, 0, 0.24);
    /* 当前激活分页的颜色 */
    opacity: 1;
}

.section3-title {
    color: var(--Text-Primary, #000);
    font-size: 20rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1.4;
    /* 140% */
}

.section3-img-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    gap: 7rem;
}

.section3-item {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.section3-item-img {
    width: 82%;
    margin: 0 auto;
}

/* .move-left-10 {
  width: calc(100% + 12px);
  transform: translateX(-12px);
} */
.section3-inner-img {
    flex-shrink: 0;
    height: 160rem;
}

.section3-item-text {
    color: #000;
    font-size: 12rem;
    font-weight: 400;
}

.section3-img-inner-box {
    display: flex;
    gap: 5rem;
}

.section3-img-inner-left,
.section3-img-inner-right {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    flex-shrink: 0;
    width: 85rem;
}

.section3-img-inner-left .section3-item-text {
    text-align: right;
}

.ar .section3-img-inner-left .section3-item-text {
    text-align: left;
}

.section3-img-inner-right .section3-item-text {}

.section3-intro {
    margin-top: 16rem;
    color: var(--Text-Secondary, rgba(0, 0, 0, 0.64));
    font-size: 16rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1.5;
    /* 150% */
}

.section3-btn-box {
    display: flex;
    gap: 12rem;
    margin-top: 64rem;
}

.section4-content {
    display: flex;
    gap: 20rem;
    margin-top: 28rem;
}

.section5-content {
    display: flex;
    flex-wrap: wrap;
    gap: 20rem;
}

.section5-item {
    border-radius: var(--Corner-Radius-RC12, 12rem);
    border: 1px solid #ebebeb;
    background: var(--Neutral-BG_A, #fff);
    padding: 32rem 24rem 32rem 32rem;
    width: calc(33.3% - 13.4rem);
    transition: border 0.3s;
}

.section5-item:hover {
    border: 1px solid #a52933;
    background: url("../../assets/image/forex/index/section5-card-bg-dot.png") no-repeat;
    background-size: 144rem 80rem;
    background-position: right top;
}

.section5-item-btn {
    margin-top: 16rem;
    display: flex;
    justify-content: flex-end;
}

.section5-item:hover .section5-item-btn {
    color: #a52933;
}

.section5-item-icon {
    width: 32rem;
}

.section5-item-title {
    margin-top: 24rem;
    color: var(--ebc--, #232222);
    font-size: 18rem;
    font-style: normal;
    font-weight: 500;
    line-height: 26rem;
    /* height: 52rem; */
    white-space: nowrap;
    /* 禁止换行 */
    overflow: hidden;
    /* 隐藏溢出内容 */
    text-overflow: ellipsis;
    /* 溢出时显示省略号 */
}

.section5-item-intro {
    margin-top: 16rem;
    color: var(--Text-Secondary, rgba(0, 0, 0, 0.64));
    font-size: 14rem;
    font-style: normal;
    font-weight: 400;
    line-height: 24rem;
}

@media (max-width: 1440px) {
    .section3-content-right {
        width: 500rem;
    }

    .section3-swiper-wrapper .swiper-slide {
        width: 400rem;
        height: 290rem;
    }
}
.forex-section:nth-of-type(1){
    margin-top: 56rem;
}
@media (max-width: 996px) {

    #ProductIframe,
    #TCIframe {
        border-radius: 16rem;
    }

    .forex-wrapper .forex-title {
        /* text-align: center; */
        font-size: 64rem;
        line-height: 80rem;
    }

    .forex-sub-title {
        font-size: 28rem;
        line-height: 44rem;
        /* text-align: center; */
    }

    .search-box {
        margin-top: 64rem;
    }

    #TCIframe {
        height: 1300rem;
    }

    .section3-swiper-wrapper {
        padding-bottom: 70rem;
    }

    .section3-content {
        flex-direction: column;
        padding: 48rem 32rem;
        border-radius: 16rem;
    }

    .section3-content-left {
        order: 2;
    }

    .section3-content-right {
        order: 1;
    }

    .section3-content-right img {
        /* height: 292rem; */
    }

    .section3-content-right {
        width: 600rem;
    }

    .section3-item-img {
        width: 76%;
    }

    .section3-swiper-wrapper .swiper-slide {
        width: 480rem;
        height: 350rem;
    }

    .section3-item-title {
        font-size: 16rem;
    }

    .section3-item-text {
        font-size: 14rem;
    }

    .section3-icon {
        display: none;
    }

    .section3-title {
        margin: 0 auto 0;
        font-size: 36rem;
        line-height: 52rem;
        text-align: center;
        max-width: 90%;
    }

    .section3-intro {
        font-size: 28rem;
        line-height: 44rem;
        text-align: center;
    }

    .section3-btn-box {
        margin-top: 64rem;
        justify-content: center;
        gap: 24rem;
    }

    #ProductIframe {
        height: 750rem;
    }

    .section5-content {
        flex-direction: column;
        gap: 32rem;
    }

    .section5-item {
        display: flex;
        align-items: center;
        width: 100%;
        padding: 40rem;
        gap: 32rem;
        border-radius: 16rem;
    }

    .section5-item-icon {
        flex-shrink: 0;
        width: 64rem;
        height: 64rem;
    }

    .section5-item-title {
        position: relative;
        margin-top: 0;
        font-size: 32rem;
        line-height: 48rem;
        font-weight: 400;
        flex-grow: 1;
        padding-right: 40rem;
    }

    .section5-item-title::after {
        position: absolute;
        right: 0;
        top: 0;
        content: "\e618";
        font-size: 40rem;
        font-family: "iconfont" !important;
        color: #c2c2c2;
    }

    .section5-item-intro {
        display: none !important;
    }

    .section5-item-btn {
        display: none !important;
    }
}
</style>